export const CONTACT_EMAIL = 'evaluationTA@ucdenver.edu';
